import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Production domain used for all canonical / og:url tags (single preferred version).
const SITE = "https://csrjournal.org";

// Short alias routes -> their preferred canonical path (avoids duplicate indexable pages).
const CANONICAL_MAP = {
  "/authors": "/instructions-for-authors",
  "/aims-scope": "/aims-and-scope",
  "/peer-review": "/peer-review-process",
  "/ethics": "/publication-ethics",
  "/apc": "/article-processing-charge",
  "/privacy": "/privacy-notice",
};

// Non-indexable areas (admin panel, login, manuscript submission form).
const isPrivate = (path) => path.startsWith("/admin") || path === "/submit";

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
  return el;
}

function upsertMeta(prop, content, attr = "property") {
  let el = document.head.querySelector(`meta[${attr}="${prop}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, prop);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
  return el;
}

function removeLink(rel) {
  const el = document.head.querySelector(`link[rel="${rel}"]`);
  if (el) el.remove();
}

export default function RouteSEO() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Normalize: strip trailing slash except for root.
    let path = pathname !== "/" ? pathname.replace(/\/+$/, "") : "/";
    path = CANONICAL_MAP[path] || path;

    if (isPrivate(path)) {
      // Do not present private pages as canonical/indexable.
      upsertMeta("robots", "noindex, nofollow", "name");
      removeLink("canonical");
      return;
    }

    upsertMeta("robots", "index, follow", "name");
    const url = path === "/" ? `${SITE}/` : `${SITE}${path}`;
    upsertLink("canonical", url);
    upsertMeta("og:url", url);
  }, [pathname]);

  return null;
}
